import { BrowserBroadcast } from '@adapters/broadcast/browserBroadcast';
import { TaggingMetricMapper } from '@adapters/tagging/taggingMetricMapper';
import { Logger } from '@core/model/domain/logger';
import { TaggingContainer, TaggingTracker } from '@core/model/domain/taggingTracker';
import { OneyIdentifier } from '@core/model/framework/OneyIdentifier';
import { HttpClient } from '@core/model/framework/httpClient';
import { WaitOnCaseStateNotificationGateway } from '@core/model/gateway/waitOnCaseStateNotificationGateway';
import { WaitOnBankAccountAnalysisCompletionGateway } from '@core/model/gateway/waitOnBankAccountAnalysisCompletionGateway';
import { WaitOnWebauthNotificationGateway } from '@core/model/gateway/waitOnWebauthNotificationGateway';
import { AccountService } from '@core/model/service/accountService';
import { BankService } from '@core/model/service/bankService';
import { ConsentService } from '@core/model/service/consentService';
import { ClerkService } from '@core/model/service/clerkService';

export const SERVICE_ID = {
  // Http clients
  openBankingHttpClient: OneyIdentifier<HttpClient>('openBankingHttpClient'),

  // Services
  bankService: OneyIdentifier<BankService>('bankService'),
  accountService: OneyIdentifier<AccountService>('accountService'),
  consentService: OneyIdentifier<ConsentService>('consentService'),
  clerkService: OneyIdentifier<ClerkService>('clerkService'),

  taggingTracker: OneyIdentifier<TaggingTracker>('taggingTracker'),
  taggingMetricMapper: OneyIdentifier<TaggingMetricMapper>('taggingMetricMapper'),
  logger: OneyIdentifier<Logger>('logger'),
  serverLogger: OneyIdentifier<Logger>('serverLogger'),
  browserBroadcast: OneyIdentifier<BrowserBroadcast>('browserBroadcast'),

  // Gateways
  waitOnWebauthNotificationGateway: OneyIdentifier<WaitOnWebauthNotificationGateway>(
    'waitOnWebauthNotificationGateway'
  ),
  waitOnCaseStateNotificationGateway: OneyIdentifier<WaitOnCaseStateNotificationGateway>(
    'waitOnCaseStateNotificationGateway'
  ),
  waitOnBankAccountAnalysisCompletionGateway: OneyIdentifier<WaitOnBankAccountAnalysisCompletionGateway>(
    'waitOnBankAccountAnalysisCompletionGateway'
  ),

  // Constants
  waitOnWebauthTimeoutInSeconds: OneyIdentifier<number>('waitOnWebauthTimeoutInSeconds'),
  waitOnWebauthIntervalInSeconds: OneyIdentifier<number>('waitOnWebauthIntervalInSeconds'),

  waitOnCaseStateTimeoutInSeconds: OneyIdentifier<number>('waitOnCaseStateTimeoutInSeconds'),
  waitOnCaseStateIntervalInSeconds: OneyIdentifier<number>('waitOnCaseStateIntervalInSeconds'),

  waitOnBankAccountAnalysisCompletionTimeoutInSeconds: OneyIdentifier<number>(
    'waitOnBankAccountAnalysisCompletionTimeoutInSeconds'
  ),
  waitOnBankAccountAnalysisCompletionIntervalInSeconds: OneyIdentifier<number>(
    'waitOnBankAccountAnalysisCompletionIntervalInSeconds'
  ),

  taggingContainers: OneyIdentifier<Array<TaggingContainer>>('taggingContainers'),
  env: OneyIdentifier<'dev' | 'preprod' | 'prod'>('env'),

  // Feature flag
  isTrackingEnabled: OneyIdentifier<boolean>('isTrackingEnabled'),
};
